<template>
  <el-dialog :title="$i18n.t('wm_lang_cda4d5')" :visible.sync="innerVisible" :close-on-click-modal="false" width="720px">
    <div class="alertWinBox">
      <!--<RcptSelector :rcpts="rcpts" :orgTrees="orgTrees" :persTrees="persTrees" ref="rcptSelector"/>-->
      <div class="el-row">
        <div class="el-col el-col-11">
          <div class="left">
            <div class="el-input el-input--small el-input-group el-input-group--append">
              <label>
                <input type="text" v-bind:value="autocompleteFilterText" v-on:input="onChangeAutocompleteFilterText" autocomplete="off"
                       :placeholder="$i18n.t('wm_lang_d28df0')+'...'" class="el-input__inner">
              </label>
              <div class="el-input-group__append">
                <button @click="clearAutocomplete()" type="button" class="el-button el-button--default" style="padding: 12px;"><i
                    v-show="!enableAutocomplete" class="el-icon-search"/><i v-show="enableAutocomplete" class="el-icon-close"/></button>
              </div>
              <ul v-if="enableAutocomplete" class="ui-corner-all nice_scroll" style="max-height: 356px;">
                <li v-for="(item, index) in autocompleteItems" :key="index" :item="item" @click.prevent="toggleAutocompleteItem(item)">
                  <label class="el-checkbox" :class="{'is-checked': item.selected}">
                                            <span class="el-checkbox__input" :class="{'is-checked': item.selected}"><span
                                                class="el-checkbox__inner"/>
                                            <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value=""></span>
                    <span class="el-checkbox__label">{{ item.first }}<b>{{ item.mid }}</b>{{ item.last }}</span>
                  </label>
                </li>
                <li v-if="autocompleteItems.length === 0"><span class="el-checkbox__label note-association">{{$t("wm_lang_html_ab9ed8")}}</span></li>
                <li v-if="autocompleteItems.length >= 200"><span
                    class="el-checkbox__label note-association">{{$t("wm_lang_html_5120e6")}}{{ autocompleteItems.length }}{{$t("wm_lang_html_413db9")}}</span>
                </li>
              </ul>
            </div>
            <div class="mt10">
              <el-tabs type="border-card">
                <el-tab-pane :label="$i18n.t('wm_lang_d43e13')">
                  <TreeView :root="orgTrees" :selector="selector" :clickCallback="handleNodeClick" class="nice_scroll"/>
                </el-tab-pane>
                <el-tab-pane :label="$i18n.t('wm_lang_d3298c')" v-if="persAddressPriv">
                  <TreeView :root="persTrees" :selector="selector" :clickCallback="handleNodeClick" class="nice_scroll"/>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="el-col el-col-2">
          <div class="center">
            <a style="height:100%" :title="$i18n.t('wm_lang_153fa6')" @click="addRcpts(selectedRcpts.address)" class="el-link el-link--primary"> <span
                class="el-link--inner"><i class="el-icon-d-arrow-right"/></span></a>
            <!--<a title=this.$i18n.t('wm_lang_fb5bf1') @click="addRcpts(selectedRcpts.tos)" class="el-link el-link&#45;&#45;primary"> <span class="el-link&#45;&#45;inner"><i class="el-icon-d-arrow-right"/></span></a>-->
            <!--<a title=this.$i18n.t('wm_lang_24969a') @click="addRcpts(selectedRcpts.ccs)" class="el-link el-link&#45;&#45;primary"><span class="el-link&#45;&#45;inner"><i class="el-icon-d-arrow-right"/></span></a>-->
            <!--<a title=this.$i18n.t('wm_lang_76ea0d') @click="addRcpts(selectedRcpts.bccs)" class="el-link el-link&#45;&#45;primary"><span class="el-link&#45;&#45;inner"><i class="el-icon-d-arrow-right"/></span></a>-->
          </div>
        </div>
        <div class="el-col el-col-11">
          <div class="right" style="border-top: 1px solid #e6e6e6;">
            <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-8930" aria-describedby="el-collapse-content-8930">
              <div role="button" id="el-collapse-head-8930" tabindex="0" class="el-collapse-item__header is-active">
                {{$t("custom_lang_0038")}}<span id="maxNumDom">(<span id="maxNumTip" class="maxNumTip">{{ selectedRcptsCount }}</span>/1000)</span>
                <i class="header-icon el-icon-delete ml10" @click="clearRcpts()"/>
              </div>
            </div>
            <div class="el-collapse-item__content">
              <div>
                <ul class="selected_to selected_person nice_scroll" style="height:398px;">
                  <li v-for="(rcpt,index) in selectedRcpts.address" :key="index" @click="removeRcpts(selectedRcpts.address, index)">
                    {{ rcpt.name }}&lt;{{ rcpt.email }}&gt;
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelDialog">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
      <el-button type="primary" @click="addAddress">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _ from "lodash";
import TreeView from '../core/tree/TreeView.vue';
import OrgContacts from "../core/common/OrgContacts";
import BaseAutocomplete from "../views/member_selector/BaseAutocomplete";
import dialogHandle from "../../utils/dialogHandle";
import BaseContactTree from "../core/common/BaseContactTree";

export default {
    name: "selectAddressDialog",
    mixins: [dialogHandle, BaseContactTree, BaseAutocomplete],
    components: {
        TreeView,
    },

    props: {
        getOrgTrees: {
            type: Function,
            default: null
        },
        getOrgTrees: {
            type: Function,
            default: null
        },
        getPersTrees: {
          type: Function,
          default: null
        },
        getMailAddress: {
            type: Function,
            default: null
        },
        cancelAddressContact: {
            type: Function,
            default: null
        }
    },

    data: function () {
        return {
            rcpts: {
                address: []
            },
            //选择的收件人、抄送人、密送人
            selectedRcpts: {
                address: []
            },
        };
    },

    created() {
        //回显之前已选的收件人
        this.selectedRcpts.address = _.concat(this.rcpts.address);
    },

    computed: {
        /**
         * 所有收件人数量
         * @returns {number}
         */
        selectedRcptsCount() {
          return this.selectedRcpts.address.length;
        },
        selectedRcptsMail() {
          return this.selectedRcpts.address.map(item => item.email);
        }
    },

    methods: {
        addAddress() {
            if (this.getMailAddress) {
                this.getMailAddress(this.selectedRcpts);
            }
            this.cancelDialog()
        },

        cancelDialog() {
            if (this.cancelAddressContact) {
                this.cancelAddressContact();
            }
            this.selectedRcpts.address = [];
        },

        /**
         * 添加收件人、抄送、密送
         * @param rcpts
         */
        addRcpts(rcpts) {
          const self = this;
          let count = OrgContacts.Constant.MAX_RCPT_SELECTED_COUNT - this.selectedRcptsCount;
          if (count > 0) {
              this.autocompleteItems.forEach(function (value) {
                  if (value.selected && count-- > 0) {
                      rcpts.push(value);
                  }
              });
          }
          if (count > 0) {
              this.selector.selectIds.forEach(function (value) {
                  if (count-- > 0 && self.selectedRcptsMail.indexOf(value.email) === -1) {
                      rcpts.push(value);
                  }
              });
          }
          this.clearAutocomplete();
          this.clearSelected();
        },

        /**
         * 移除指定收件人、抄送、密送
         * @param rcpts
         * @param index
         */
        removeRcpts(rcpts, index) {
            if (rcpts && Array.isArray(rcpts) && rcpts.length > 0) {
                rcpts.splice(index, 1);
            }
        },

        /**
         * 清除所有收件人、抄送、密送
         */
        clearRcpts() {
            this.selectedRcpts.address.splice(0, this.selectedRcpts.address.length);
        },

        /**
         * 节点点击回调
         */
        handleNodeClick() {
            console.log(this.$i18n.t('wm_lang_b43f83'))
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sub/selectAddressDialog.vue